import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../appUtils/axiosConfig";

const initialState = {
    isLoading: false,
    error: null,
    categories: [],
    activeCategories:[],
    isCategoriesLoading: false
}

export const getCategories = createAsyncThunk(
    'get_categories_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getCategoriesStart());
            const response = await axios.get(`/categories/get_categories.php`)
            if (response?.data?.status === 'success') {

                dispatch(getCategoriesSuccess(response?.data?.data))
            }

            return response?.data?.data
        } catch (error) {
            dispatch(getCategoriesFailure(error.response.data.message))
        }
    }
)
export const getActiveCategories = createAsyncThunk(
    'get_active_categories',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getActiveCategoriesStart());
            const response = await axios.get(`/categories/get_active_categories.php`)
            if (response?.data?.status === 'success') {
                dispatch(getActiveCategoriesSuccess(response?.data?.data))
            }

            return response?.data?.data
        } catch (error) {
            dispatch(getActiveCategoriesFailure(error.response.data.message))
        }
    }
)


const categoriesSlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {
        getCategoriesStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getCategoriesSuccess(state, action) {
            state.categories = action.payload;
            state.isLoading = false;
        },
        getCategoriesFailure(state, action) {
            state.categories = null;
            state.isLoading = false;
            state.error = action.payload;
        },
        getActiveCategoriesStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getActiveCategoriesSuccess(state, action) {
            state.activeCategories = action.payload;
            state.isLoading = false;
        },
        getActiveCategoriesFailure(state, action) {
            state.activeCategories = null;
            state.isLoading = false;
            state.error = action.payload;
        }  
    }
})

export const { getCategoriesSuccess, getCategoriesStart, getCategoriesFailure, getActiveCategoriesSuccess, getActiveCategoriesStart, getActiveCategoriesFailure } = categoriesSlice.actions;

export default categoriesSlice.reducer;